/**
 * An employer's ad, written into a group-post comment.
 *
 * The comments API stores a content string and nothing else, so the offer rides along
 * inside the text. The layout is line-per-field so the same string both unpacks into a
 * job card in the feed (parseJobComment in CandidateSearchDemo) and still reads as a
 * sensible message anywhere that renders it raw:
 *
 *   НОМИН Холдинг
 *   Тогооч
 *   Цалин: 1,800,000₮
 *   Байршил: Баянзүрх
 *   https://diil.app/job/16180
 *
 * Shared, because two places make this offer now: a reply in the feed, and the "Ажил
 * санал болгох" button on a candidate's profile.
 */
import { formatEmployerSalary } from "./employerSalary";

export const JOB_LINK_RE = /(https?:\/\/\S*?\/job\/(\d+))/;

export const buildJobComment = (job) => [
  job.companyName || "",
  job.title || "",
  // Labelled so parseJobComment can identify salary vs location reliably even when the
  // salary is text like "Цалин тохиролцоно" (no digits, no ₮).
  //
  // formatEmployerSalary, not job.salary: the API returns the Cyrillic "сая" as "???",
  // and the comment text is stored verbatim — a raw value would freeze the mangling into
  // the thread forever.
  formatEmployerSalary(job) ? `Цалин: ${formatEmployerSalary(job)}` : "",
  job.district ? `Байршил: ${job.district}` : "",
  `${window.location.origin}/job/${job.id}`,
].filter(Boolean).join("\n");
